import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowConstructionDraftReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div>
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			 {getServiceResult ? <div>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>		
				<tbody>
					<tr>
						<td><b class="b1">شماره پروانه:</b> {getServiceResult.ConstructionNumber} </td>
						<td><b class="b1">نوع پروانه:</b> {getServiceResult.ConstructionType} </td>
						<td><b class="b1">تاریخ صدور:</b> {getServiceResult.IssueDate} </td>
					</tr>
					<tr>
						<td><b class="b1">مساحت طبق سند:</b> {getServiceResult.AreaByDocument} </td>
						<td><b class="b1">نوع زمین:</b> {getServiceResult.LandUsage} </td>
						<td><b class="b1">زیر بنای موجود:</b> {getServiceResult.AreaForSection} </td>
					</tr>
					<tr>
						<td><b class="b1">مساحت پس از اصلاحی:</b> {getServiceResult.AreaAfterCorrection} </td>
						<td><b class="b1">کاربری زمین:</b> {getServiceResult.LandUsage} </td>
						<td><b class="b1">زیر بنای قابل احداث:</b> {getServiceResult.BuildableSubstructionArea} </td>
					</tr>	
					<tr>	
						<td colspan="3"><b class="b1">توضیحات پیش نویس:</b> {getServiceResult.DraftDescription} </td>
					</tr>						
				</tbody>
			</table>
			<br/>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.SupervisorEngineer}
				customHeaders={{
					"EngineerTitle": "عنوان مهندس",
					"FullName": "نام مهندس"
				}}		
			/>				
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
